module.exports = __webpack_public_path__ + "static/CRS_01_new-edfdb81d36b72afdbf0885be4337f480.svg";